<template>
  <div class="relative w-full">
    <!-- Sanne: illustrations with a step counter and Next (Figma Tutorial section) -->
    <template v-if="isSanne">
      <sanne-step
        v-for="(page, i) in sannePages"
        :key="page.audio"
        :show="isCurrent(i + 1)"
        :step="i + 1"
        :title="$t(page.title)"
        :image="page.image"
        :audio="page.audio"
        @next="next"
        @leave="leave"
      />
    </template>
    <template v-else>
      <remove-acc :show="isCurrent(1)" @next="next" @skip="done" />
      <wear-tight :show="isCurrent(2)" @next="next" @skip="done" />
      <tie-hair :show="isCurrent(3)" @next="next" @skip="done" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ScanProcess from '@/modules/scan-process';
import handleArmDetection from '@/mixins/arm-detection';
import page from '@/mixins/page';
import leave from '@/mixins/leave';
import brandMode from '@/mixins/brand-mode';

import WearTight from '../components/ThingsToNote/WearTight.vue';
import TieHair from '../components/ThingsToNote/TieHair.vue';
import RemoveAcc from '../components/ThingsToNote/RemoveAcc.vue';
import SanneStep from '../components/ThingsToNote/SanneStep.vue';
import removeAccImage from '../assets/sanne/tutorial/remove-accessories.svg';
import wearTightImage from '../assets/sanne/tutorial/wear-tight.svg';
import tieHairImage from '../assets/sanne/tutorial/tie-hair.svg';

// same voice-overs and order as the default lottie pages
const SANNE_PAGES = [
  { title: 'sanne.tutorial_remove_acc', image: removeAccImage, audio: '5-Remove_accessories' },
  { title: 'sanne.tutorial_wear_tight', image: wearTightImage, audio: '6-Skin_tight' },
  { title: 'thingstonote.tie_hair', image: tieHairImage, audio: '7-Tie_hair' },
];

export default {
  name: 'ThingsToNote',
  components: {
    WearTight,
    TieHair,
    RemoveAcc,
    SanneStep,
  },
  mixins: [page, handleArmDetection, leave, brandMode],
  created() {
    if (this.skipTutorial) {
      this.done();
    } else {
      this.$nextTick(() => {
        this.next();
      });
    }
  },
  data: () => ({
    currentPageNo: 0,
    sannePages: SANNE_PAGES,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.done();
      }
    },
    done() {
      if (ScanProcess.withHandles()) {
        this.$events.goto('ScanBodyWithHandles');
      } else if (this.skipTutorial) {
        this.startArmDetection();
        this.$events.goto('ScanBody');
      } else {
        this.$events.goto('ChooseToStart');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    ...mapState('mtmUser', ['skipTutorial']),
    lastScreen() {
      return this.currentPageNo >= 3;
    },
  },
};
</script>
